import { User } from 'frontend/types';
import { DateTime, Interval } from 'luxon';

export function userCanRefer(user: User): boolean {
  return !!user.referral_url;
}

export function shouldOverrideHeaderButton(user: User): boolean {
  return userCanRefer(user) && userIsSubscriberOrOnFreeTrial(user);
}

export function getOverriddenHeaderButtonText(): string {
  return isGiftSeason() ? 'Gift Premium' : 'Refer a Friend';
}

export function getOverriddenHeaderButtonTextMobile(): string {
  return isGiftSeason() ? 'Gift' : 'Refer';
}

export function getOverriddenHeaderButtonLink(): { name: string } {
  return isGiftSeason() ? { name: 'gift_purchase_plans' } : { name: 'referrer_home' };
}

export function getOverridenHeaderButtonAxId(): string {
  return isGiftSeason() ? 'clicked_header_gift_premium' : 'clicked_header_refer_friend';
}

export function freeMonthsToDollarAmount(
  freeMonths: number,
  oneMonthDollarAmount: number = 12.49,
): number {
  return oneMonthDollarAmount * freeMonths;
}

function userIsSubscriberOrOnFreeTrial(user: User): boolean {
  return !!(user.is_during_trial || user.has_brilliant_premium);
}

function isGiftSeason(): boolean {
  const now = DateTime.local().toUTC();
  const startOfGiftSeason = DateTime.fromObject({ day: 15, month: 11, year: now.year });
  const endOfGiftSeason = DateTime.fromObject({ day: 1, month: 1, year: now.year + 1 });
  const giftSeason = Interval.fromDateTimes(startOfGiftSeason, endOfGiftSeason);
  return giftSeason.contains(now);
}
